import React, { useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import CreateIcon from "@material-ui/icons/Create";
import DescriptionIcon from "@material-ui/icons/Description";
import GroupIcon from "@material-ui/icons/Group";
import * as Glob from "src/Globale";
import { Trad } from "src/components";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _Button, _ExposureLimitForm, _InfoSection } from "../components";
import { _Autocomplete, _DateField, _Select } from "../form";

export interface IRouteParam {
    ID_Anag: string;
    ID_FideAffidamento: string;
    DataRiferimento?: string;
}

export const _ExposureLimit: React.FC<Glob.IRouteGlobaleProps> = props => {
    const ID_Anag = Number(useParams<IRouteParam>().ID_Anag) || 0;
    const ID_FideAffidamento = Number(useParams<IRouteParam>().ID_FideAffidamento) || 0;
    const isCreated = ID_FideAffidamento > 0;

    useEffect(() => {
        if (!Glob.AzioneAbilitata("FideAffidamentoController", Glob.Lettura)) {
            location.replace("/ErroreAccesso");
            return;
        }
    }, []);

    useEffect(() => {
        let ID_MenuMain = 0;
        let VariabiliMenu = {};

        if (isCreated) {
            ID_MenuMain = 24;
            VariabiliMenu = { ["{ID_FideAffidamento}"]: ID_FideAffidamento };
        }

        props.SetMenu({ ...Glob.GetMenu(), Main: "Affidamento", ID_MenuMain, VariabiliMenu });
    }, [useParams<IRouteParam>().ID_FideAffidamento]);

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={CreateIcon} Title="Affidamento">
                    {isCreated && (
                        <a href={`/file/${ID_FideAffidamento}`}>
                            <Tooltip title={Trad.Trad("Documenti")}>
                                <IconButton size="small" aria-label="add">
                                    <DescriptionIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </a>
                    )}
                    <NavLink to={`/anagrafica/${ID_Anag}/fideaffidamento/${ID_FideAffidamento}/coobbligato`}>
                        <Tooltip title={Trad.Trad("Coobbligati")}>
                            <IconButton size="small" aria-label="add">
                                <GroupIcon color="action" />
                            </IconButton>
                        </Tooltip>
                    </NavLink>
                    {Glob.AzioneAbilitata("FideAffidamentoController", Glob.Scrittura) && (
                        <NavLink to={`/anagrafica/${ID_Anag}/fideaffidamento/0`}>
                            <Tooltip title={Trad.Trad("Nuovo")}>
                                <IconButton size="small" aria-label="add">
                                    <AddIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </NavLink>
                    )}
                </_PageTitle>
                <_MainContent WithPaper={false}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <_InfoSection DataUrl={`/api/anag/Contesto?ID_Anag=${ID_Anag}`} LinkUrl={`/anagrafica/${ID_Anag}`} Title="Anagrafica" />
                        </Grid>
                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <_ExposureLimitForm ID_Anag={ID_Anag} ID_FideAffidamento={ID_FideAffidamento} />
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/ExposureLimit.tsx